import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { USDT } from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, P3 } from '../../../styles/FontStyles';
import { Box, CheckIconBox, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Icon, IconPackagesCheck } from '../../../styles/Icons';
import { FlexBetween, FlexCenter } from '../../../styles/stylesStyled';
import { Button } from '../Button/Button';
import { MostPopular } from './VirtualOfficeSubscription.styled';

interface VirtualOfficeCard {
  plan: any;
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
}

export const VirtualOfficeCard = ({
  plan,
  setIsOpen,
  setSelected,
  setStep
}: // setSelectedHub
VirtualOfficeCard) => {
  const { t } = useTranslation('settings');

  return (
    <Box style={{ display: 'flex' }} border>
      <Flexed column between style={{ flexGrow: 1 }}>
        <div>
          <P3 center bold mb='5'>
            {plan.title}{' '}
            {plan.title2 && (
              <span
                style={{ color: colors.primary900 }}>{`${plan.title2}`}</span>
            )}
          </P3>

          <H2 center bold mb='10'>
            ${plan.price} {USDT}
          </H2>

          {plan.id === 2 && (
            <Flexed center column mb='20'>
              <MostPopular>
                <CaptionText color={color.colors.neutral0}>
                  PROMOTION
                </CaptionText>
              </MostPopular>
            </Flexed>
          )}
          {plan.benefits.map((benefit: any, i: any) => (
            <div style={{ marginBottom: 10 }} key={i}>
              <FlexCenter>
                <CheckIconBox
                  style={{ flex: 'none' }}
                  background={benefit.text === ''}>
                  <Icon>
                    <IconPackagesCheck />
                  </Icon>
                </CheckIconBox>
                <P3>{benefit.text}</P3>
              </FlexCenter>
            </div>
          ))}
        </div>
        <div>
          <H3
            style={{ visibility: !plan.save ? 'hidden' : 'visible' }}
            color={colors.neutral900}
            center>
            {`${t('virtual_office.plans.save')} ${plan.save || '00'}%`}
          </H3>

          <Button
            w='100%'
            mt='15'
            onClick={() => {
              setSelected(plan);
              setIsOpen(true);
              setStep(1);
            }}>
            {t('virtual_office.plans.plan_access', { access: plan.access })}
          </Button>
        </div>
      </Flexed>
    </Box>
  );
};
